var API_URL = process.env.REACT_APP_API_URL;
export var EID_REDIRECT_URL = "".concat(API_URL, "/api/b2cauthentication/eid");
export var SELF_REG_REDIRECT_URL = "".concat(API_URL, "/api/b2cauthentication/selfreg");
export var CORP_REDIRECT_URL = "".concat(API_URL, "/api/b2cauthentication/corp");
export var LOGOUT_URL = API_URL + "/api/v1/User/Logout";
export var FORGOT_PASSWORD_URL = process.env.REACT_APP_UMBRACO_PORTAL_URL + "/account/forgotpassword";
